module.exports = __webpack_public_path__ + "static/media/photo-example-good-corner-driveway.0dc97659.jpg";